import React, { useState } from 'react'

export const ProdottoContext = React.createContext()

const ProdottoContextProvider = (props) => {
  const [showDuplicaPersonalizzazione, setShowDuplicaPersonalizzazione] = useState(false)
  const [showQuantitaInsufficiente, setShowQuantitaInsufficiente] = useState(false)

  return (
    <ProdottoContext.Provider
      value={{
        showDuplicaPersonalizzazione,
        setShowDuplicaPersonalizzazione,
        showQuantitaInsufficiente,
        setShowQuantitaInsufficiente,
      }}
    >
      {props.children}
    </ProdottoContext.Provider>
  )
}

export default ProdottoContextProvider
